module.exports = __webpack_public_path__ + "img/rugby.4281d8df.svg";